"use client";

import { X } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import posthog from "posthog-js";
import { useEffect, useState } from "react";
import Button from "./ui/Button";

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if the user has already made a choice
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowBanner(true);
    } else {
      // Re-apply the choice to PostHog just in case
      if (consent === "accepted") {
        posthog.opt_in_capturing();
      } else if (consent === "declined") {
        posthog.opt_out_capturing();
      }
    }
  }, []);

  const handleAccept = () => {
    posthog.opt_in_capturing();
    posthog.capture("cookie_consent_accepted");
    localStorage.setItem("cookie_consent", "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    posthog.capture("cookie_consent_declined");
    posthog.opt_out_capturing();
    localStorage.setItem("cookie_consent", "declined");
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed right-0 bottom-0 left-0 z-[100] p-4 md:p-6"
        >
          <div className="relative mx-auto max-w-4xl overflow-hidden rounded-2xl border border-white/20 bg-white/80 shadow-2xl backdrop-blur-xl">
            <button
              onClick={() => setShowBanner(false)}
              className="absolute top-4 right-4 cursor-pointer rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-900"
              aria-label="Close"
            >
              <X size={20} />
            </button>
            <div className="flex flex-col items-center justify-between gap-6 p-6 md:flex-row md:p-8">
              <div className="flex-1 space-y-2 text-center md:text-left">
                <h3 className="text-lg font-bold text-gray-900">
                  Cookie Preferences
                </h3>
                <p className="text-sm leading-relaxed text-gray-600">
                  We use cookies and PostHog to analyze our traffic and improve
                  your experience. By clicking &quot;Accept&quot;, you consent
                  to our use of these tools. Read our{" "}
                  <a
                    href="/privacy-policy"
                    className="hover:text-primary underline"
                  >
                    Privacy Policy
                  </a>{" "}
                  to learn more.
                </p>
              </div>

              <div className="flex flex-wrap items-center justify-center gap-3 md:justify-end">
                <Button
                  onClick={handleDecline}
                  className="text-primary border-primary shadow-primary/20 rounded-xl border-2 border-solid bg-transparent px-8 shadow-lg"
                >
                  Decline
                </Button>
                <Button
                  onClick={handleAccept}
                  className="shadow-primary/20 rounded-xl px-8 shadow-lg"
                >
                  Accept
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
